"use client";
import React from "react";
import { Empty } from "antd";
import { type Blog } from "@/lib/@types/api/blog";
import BlogItemDefault from "@/components/Blogs/BlogItemDefault";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

interface BlogListProps {
	blogList: Blog.BlogListItem[];
}

const BlogList: React.FC<BlogListProps> = ({ blogList }) => {
	const t = useTranslations("cases");

	return blogList.length > 0 ? (
		<div className="list-blog grid grid-cols-3 gap-x-5 gap-y-5 max-md:grid-cols-1">
			{blogList.map((item) => (
				<BlogItemDefault key={item.blog_slug} news={item} />
			))}

			{/* 默认卡片 */}
			{/* <Link
				href="/upload"
				className="block transform cursor-pointer overflow-hidden rounded-lg shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-xl"
				style={{ backgroundColor: "#3383ff" }}
			>
				<div className="flex h-full min-h-[390px] flex-col items-center justify-center px-6 py-8 text-center text-white">
					<div className="mb-4">
						<h3 className="mb-2 text-2xl font-bold">{t("defaultCardtitle")}</h3>
						<p className="text-sm text-blue-100">{t("defaultCardsubtitle")}</p>
					</div>
					<button className="rounded-lg bg-white px-6 py-3 font-semibold text-blue-600 transition-colors duration-300 hover:bg-blue-50">
						{t("defaultCardbuttonText")}
					</button>
				</div>
			</Link> */}
		</div>
	) : (
		<div className="flex h-full w-full items-center justify-center">
			{" "}
			<Empty />
		</div>
	);
};

export default BlogList;
